export function text(textString) {
    return {text: textString, hoverText: null}
}

export function link(linkText, hoverText) {
  return {text: linkText, hoverText: hoverText}
}

export function para(...spans) {
   return spans
}